import { combineEpics, ofType } from 'redux-observable';
import {
  switchMap, catchError, mergeMap, map,
} from 'rxjs/operators';
import { normalize } from 'normalizr';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import {
  confirmRoleAuditSuccess,
  confirmUserAuditSuccess, fetchAuditPendingRoleIdsForSpaceIdSuccess,
} from './actions';
import { entitiesFetchSuccess } from '../../../store/entities/actions';
import { spaceSchema } from '../../../store/schema';


const confirmUserAudit = (action$) => action$.pipe(
  ofType(actionTypes.CONFIRM_USER_AUDIT),
  switchMap((action) => api.audit.confirmUserAudit(action.spaceId).pipe(
    map((response) => normalize(response.body, spaceSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      confirmUserAuditSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const fetchPendingRoleIdsForSpaceId = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_PENDING_ROLE_IDS),
  switchMap((action) => api.audit.fetchPendingRoles(action.spaceId).pipe(
    mergeMap((response) => [
      fetchAuditPendingRoleIdsForSpaceIdSuccess(response.body, action.spaceId),
    ]),
    catchError(() => []),
  )),
);

const confirmRoleAudit = (action$) => action$.pipe(
  ofType(actionTypes.CONFIRM_ROLE_AUDIT),
  switchMap((action) => api.audit.confirmRoleAudit(action.spaceId, action.role).pipe(
    map((response) => normalize(response.body, spaceSchema)),
    mergeMap(({ entities }) => [
      entitiesFetchSuccess(entities),
      confirmRoleAuditSuccess(action.spaceId, action.role.id),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


export default combineEpics(
  confirmUserAudit,
  confirmRoleAudit,
  fetchPendingRoleIdsForSpaceId,
);
